<footer class="main-footer">
  <div class="main-footer-decor" aria-hidden="true"></div>

  <div class="main-footer-inner">

    @if (temColunas()) {
      <div class="main-footer-grade">

        @if (mostraMarca()) {
          <div class="main-footer-marca">
            @if (brasaoUrl(); as brasao) {
              <span class="main-footer-brasao-tile">
                <img
                  class="main-footer-brasao"
                  [src]="brasao"
                  [alt]="altBrasao()"
                  (error)="brasaoIndisponivel.set(true)"
                />
              </span>
            }
            @if (nome(); as nomeOrgao) {
              <span class="main-footer-marca-texto">{{ nomeOrgao }}</span>
            }
          </div>
        }

        @if (links().length > 0) {
          <nav class="main-footer-coluna" aria-labelledby="main-footer-acesso-rapido">
            <h2 class="main-footer-titulo" id="main-footer-acesso-rapido">Acesso rápido</h2>
            <ul class="main-footer-lista">
              @for (item of links(); track $index) {
                <li>
                  @if (item.destinoInterno; as destino) {
                    <a class="main-footer-link" [routerLink]="destino">{{ item.rotulo }}</a>
                  } @else if (item.novaAba) {
                    <a
                      class="main-footer-link"
                      [href]="item.href"
                      target="_blank"
                      rel="noopener noreferrer"
                      [attr.aria-label]="item.rotulo + ' (abre em nova aba)'"
                    >{{ item.rotulo }}</a>
                  } @else {
                    <a class="main-footer-link" [href]="item.href">{{ item.rotulo }}</a>
                  }
                </li>
              }
            </ul>
          </nav>
        }

        @if (mostraEndereco()) {
          <section class="main-footer-coluna" aria-labelledby="main-footer-endereco">
            <h2 class="main-footer-titulo" id="main-footer-endereco">Endereço</h2>

            @if (endereco().length > 0) {
              <p class="main-footer-info">
                <i-lucide class="main-footer-icone" name="map-pin" size="16"></i-lucide>
                <span>
                  @for (linha of endereco(); track $index) {
                    {{ linha }}<br />
                  }
                </span>
              </p>
            }

            @if (horario(); as horarioAtendimento) {
              <p class="main-footer-info">
                <i-lucide class="main-footer-icone" name="clock" size="16"></i-lucide>
                <span>{{ horarioAtendimento }}</span>
              </p>
            }
          </section>
        }

        @if (mostraContato()) {
          <section class="main-footer-coluna" aria-labelledby="main-footer-contato">
            <h2 class="main-footer-titulo" id="main-footer-contato">Contato</h2>

            @for (contato of contatos(); track $index) {
              <p class="main-footer-info">
                <i-lucide class="main-footer-icone" [name]="contato.icone" size="16"></i-lucide>
                @if (contato.novaAba) {
                  <a
                    class="main-footer-link"
                    [href]="contato.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    [attr.aria-label]="contato.texto + ' (abre em nova aba)'"
                  >{{ contato.texto }}</a>
                } @else {
                  <a class="main-footer-link" [href]="contato.href">{{ contato.texto }}</a>
                }
              </p>
            }

            @if (mostraRedes()) {
              <app-redes-sociais class="main-footer-social"></app-redes-sociais>
            }
          </section>
        }

      </div>

      <hr class="main-footer-divisor" />
    }

    <p class="main-footer-copyright">© {{ anoAtual }} IMAP. Todos os direitos reservados.</p>
  </div>
</footer>
